import { useLogger } from '../providers/logger/Logger';
import { useEffect, useState, useCallback } from 'react';
import { LogLevel, LogAction } from '../providers/logger/logger-types';

export const useGeneralActivityLogger = (
    page: string,
    name?: string,
    id?: string,
    channelName?: string,
    channelId?: string,
    waitForPageLoad = false
) => {
    const { printLog } = useLogger();
    const [isPageLoaded, setIsPageLoaded] = useState(false);
    const [startTime] = useState(new Date().getTime());
    const url = window.location.href;

    useEffect(() => {
        if (waitForPageLoad && !isPageLoaded) return;

        if (page && name && url) {
            const loadTimeMs = new Date().getTime() - startTime;
            printLog(LogLevel.INFO, LogAction.Activity, 'Page visit', {
                page,
                name,
                id,
                channelName,
                channelId,
                url,
                loadTimeMs,
            });
        }
    }, [
        printLog,
        page,
        name,
        id,
        url,
        isPageLoaded,
        startTime,
        waitForPageLoad,
    ]);

    const pageLoadComplete = useCallback(() => {
        if (!isPageLoaded) setIsPageLoaded(true);
    }, [isPageLoaded]);

    return pageLoadComplete;
};

export const useActivityLogger = (
    page: string,
    name?: string,
    id?: string,
    waitForPageLoad = false
) => {
    return useGeneralActivityLogger(
        page,
        name,
        id,
        undefined,
        undefined,
        waitForPageLoad
    );
};

export const useArticleActivityLogger = (
    page: string,
    name?: string,
    id?: string,
    channelName?: string,
    channelId?: string,
    waitForPageLoad = false
) => {
    return useGeneralActivityLogger(
        page,
        name,
        id,
        channelName,
        channelId,
        waitForPageLoad
    );
};
